import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, Route, Routes, Navigate } from 'react-router-dom'
import { GetSchoolUnit } from '../../../store/SchoolAction';
import * as Tab from '../../../util/TabValue';
import RenderTabs from '../../misc/Tabs';
import SchoolUnitViewInfo from './SchoolUnitViewInfo';
import SchoolUnitViewTrackings from './SchoolUnitViewTrackings';
import NotFound from '../components/NotFound';
import { CoreSchoolUnit } from '../../../models/CoreSchoolUnit';
import { RequestState } from '../../../models/RequestState';
import StatusCode from '../../../util/StatusCode';
import Loading from '../../misc/Loading';
import { useTranslation } from 'react-i18next';
import DeleteDate from '../../misc/DeleteDate';
import * as Helper from '../../../util/Helper';

import { RootState } from '../../../store/store';



const SchoolUnitView = () => {
    const { t } = useTranslation(['common', 'schoolAdministration']);
    const { schoolId } = useParams();
    const dispatch = useDispatch();
    const school = useSelector<RootState, RequestState<CoreSchoolUnit>>(state => state.schools.school);

    useEffect(() => {
        if (schoolId !== undefined) {
            GetSchoolUnit(schoolId)(dispatch);
        }
    }, [dispatch, schoolId]);

    const tabs = [
        Tab.Tabs.Information,
        Tab.Tabs.Trackings,
    ];

    if (schoolId === undefined) {
        return;
    }

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/schoolunit">{t('object.schoolAdmin.school', { ns: 'common', count: 1 })}</Link> {displayName}</h1>
            {body}
        </div>
    )

    let displayName: string | undefined = '';

    switch (school.code) {
        case StatusCode.COMPLETE:
            displayName = school.data.title;
            return (renderContent(<>

                {school.data.removeDate && <DeleteDate message={t('deleteDate.schoolUnit', { ns: 'schoolAdministration', date: Helper.formatDateOnly(school.data.removeDate) })} />}
                <RenderTabs
                    tabs={tabs}
                    id={schoolId}
                    url="schoolunit" />

                <Routes>
                    <Route>
                        <Route path={Tab.Tabs.Information.url} element={<SchoolUnitViewInfo />} />
                        <Route path={Tab.Tabs.Trackings.url} element={<SchoolUnitViewTrackings />} />
                        <Route path="*" element={<Navigate replace={true} to={`/schoolunit/${schoolId}/${Tab.Tabs.Information.url}`} />} />
                    </Route>
                </Routes>
            </>));
        case StatusCode.ERROR:
            if (school.error.response?.status === 404 || school.error.response?.status === 400) {
                return (
                    <NotFound
                        header={t('object.schoolAdmin.school', { ns: 'common', count: 1 })}
                        translateKey={{ i18nKey: "notFound.school", ns: "schoolAdministration" }}
                        link="/schoolunit"
                    />
                );
            } else {
                return renderContent(<p> {school.error.response?.statusText}</p>);
            }
        default:
            return (renderContent(<Loading />));
    }
}

export default SchoolUnitView;
